import type { FC } from 'react';


import SliderContainer from './SliderContainer';
import SongInfos from './SongInfos';
import { TimeSliderAndSongInfos } from './TimeSlider.style';

interface ITimeSLider {
  songTitle?: string;
  songArtistName?: string;
  timeSliderValue: number;
  timeSliderMax: number;
  handleTimeSliderChange: (value: number | number[]) => void;
  handleTimeSliderChangeCommitted: () => void;
  remainingTime: string | null;
  controlsDisabled: boolean;
}

const Slider: FC<ITimeSLider> = ({
  songTitle,
  songArtistName,
  timeSliderValue,
  timeSliderMax,
  handleTimeSliderChange,
  remainingTime,
  handleTimeSliderChangeCommitted,
  controlsDisabled,
}) => {
  return (
    <TimeSliderAndSongInfos>
      {songTitle && songArtistName && <SongInfos {...{ songTitle, songArtistName }} />}
      <SliderContainer
        {...{
          timeSliderValue,
          timeSliderMax,
          handleTimeSliderChange,
          remainingTime,
          handleTimeSliderChangeCommitted,
          controlsDisabled,
        }}
      />
    </TimeSliderAndSongInfos>
  );
};

export default Slider;
